/* eslint-disable camelcase */
import React from "react";
import { useTranslation } from "ceco-polyglot";
import { Image } from "semantic-ui-react";
import { AllergenModal } from "../../modals/AllergenModal";
import { AllergenDeleteModal } from "../../modals/AllergenDeleteModal";
import { ActionsTable } from "ceco-window-table";
import { MoreHorizontal, Edit, Delete } from "ceicons";
import DropDownButton from "../../DropDownButton";

export default function AllergensTable(props) {
  const { allergensParsed, totalCount, _refetch, handleScroll } = props;

  const t = useTranslation();

  const columnsTable = [
    {
      key: "image",
      basis: 1,
      width: 100,
      ItemRenderer: PictureCell,
    },
    {
      key: "color",
      basis: 1,
      width: 0,
    },
    {
      key: "name",
      basis: 1,
      title: t("table-header.name"),
    },
    {
      key: "id",
      basis: 1,
      width: 100,
      ItemRenderer: <EditCell refetchData={_refetch} />,
    },
  ];

  return (
    <ActionsTable
      legend={<strong>pedidos en total o algo asi</strong>}
      actions={[]}
      allowItemSelection={false}
      footer={
        <div>
          <div className="legend" />
        </div>
      }
      allowAllItemsSelection={false}
      gridActions={[
        <div className="right floated" key="right-side">
          <strong>
            {totalCount} {t("count.allergens")}
          </strong>
        </div>,
      ]}
      items={allergensParsed}
      columns={columnsTable}
      onScrollTable={handleScroll}
    />
  );
}

const EditCell = (props) => {
  const { data, rowIndex, columnIndex, style, refetchData } = props;
  const { items } = data;
  const id = items[rowIndex][columnIndex];
  //TODO: Hay alguna otra forma para obtener el dato por el nombre?, antes utilizaba flags pero aqui me fallan.
  const name = items[rowIndex][columnIndex - 1];
  const color = items[rowIndex][columnIndex - 2];
  const image = items[rowIndex][0];

  const t = useTranslation();

  return (
    <div
      role="cell"
      style={{ ...style, flexGrow: 1, padding: "1em", border: "" }}
      className="edit cell"
    >
      <DropDownButton icon={<MoreHorizontal />}>
        <AllergenModal
          allergen={{ image, color, name, id }}
          refetchData={refetchData}
          edit
          trigger={
            <div>
              <Edit />
              <p>{t("popup.edit")}</p>
            </div>
          }
        />
        <AllergenDeleteModal
          allergenName={name}
          refetchData={refetchData}
          allergenId={id}
          trigger={
            <div className="delete-modal">
              <Delete />
              <p>{t("popup.remove")}</p>
            </div>
          }
        />
      </DropDownButton>
    </div>
  );
};
const PictureCell = (props) => {
  const { data, rowIndex, columnIndex, style } = props;
  const { items } = data;

  const image = items[rowIndex][columnIndex];
  const color = items[rowIndex][columnIndex + 1];

  return (
    <div
      role="cell"
      style={{
        ...style,
        flexGrow: 1,
        padding: "1em",
        border: "",
      }}
      className="cell"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: color,
          borderRadius: 50,
          width: 35,
          height: 35,
        }}
      >
        <Image style={{ width: 30 }} src={image} />
      </div>
    </div>
  );
};
